import { useLocation } from 'react-router-dom';
import { SiteHeader } from '../components/SiteHeader';
import { useDocumentMeta } from '../lib/useDocumentMeta';

export function NotFound() {
  useDocumentMeta({ title: 'Not Found | Tyler Wrenn' });
  const { pathname } = useLocation();

  return (
    <main>
      <SiteHeader />
      <section className="bg-gray-dark py-5">
        <div className="container">
          <h2 className="display-3 text-center">404 Not Found</h2>
          <p className="lead text-center">The requested URL {pathname} was not found.</p>
        </div>
      </section>
    </main>
  );
}
